import React from 'react';
import { Layout } from 'antd';
import 'antd/dist/antd.css';

import './self-serve-layout.css';

export const SelfServeLayout = ({ children }) => {
  return <Layout style={{ minHeight: '100vh' }}>{children}</Layout>;
};
